module.exports = __webpack_public_path__ + "img/cat.b5aad67b.png";